import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
const styles = (theme) => createStyles({
    CNHBackgroundContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: '#1b1b1b',
        padding: 0,
        margin: 0,
        position: 'relative',
        zIndex: 100,
        minHeight: '100vh',
    },
    patternLeft: {
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 101,
        width: '58%',
    },
    patternRight: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        zIndex: 101,
        maxWidth: '20%',
    },
    tapLogo: {
        width: '100%',
        maxWidth: 400,
        marginBottom: 30,
        zIndex: 105,
    },
});
const CNHBackground = (props) => {
    const { classes, children, hideLogo, imagesBaseUrl } = props;
    return (React.createElement("main", { className: classes.CNHBackgroundContainer, "data-testid": 'tap-page' },
        !hideLogo && (React.createElement("img", { alt: 'cnh', src: `${imagesBaseUrl}/cnh/assets/images/common/logo/logo.svg`, className: classes.tapLogo })),
        children));
};
export default compose(withBaseProps({ styles }))(CNHBackground);
//# sourceMappingURL=index.js.map